import type { AllRouteEndpoints } from "../routeTypes";
export const postIntegrationsDirectCdiCatalogSchemaDiffCacheKeys: AllRouteEndpoints[] = [];
